<template>
  <div class="content">
    <controlbar @input-event="setMailHistories"></controlbar>

    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <td class="table_margin"></td>
          <td class="table_from">
            <label>{{ typeLabel }}</label>
          </td>
          <td class="table_title">
            <label>{{ titleLabel }}</label>
          </td>
          <td class="table_message">
            <label>{{ messageLabel }}</label>
          </td>
          <td class="table_date">
            <label>{{ dateLabel }}</label>
          </td>
          <td class="table_result">
            <label>{{ resultLabel }}</label>
          </td>
          <td class="table_userId">
            <label>{{ userIdLabel }}</label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="mailHistory in formatDateList"
            :key="mailHistory.mailHistoryId"
          >
            <td class="table_margin"></td>
            <td class="table_from" @click="toDetail(mailHistory.mailHistoryId)">
              <label>{{ mailHistory.type }}</label>
            </td>
            <td
              class="table_title"
              @click="toDetail(mailHistory.mailHistoryId)"
            >
              <label>{{ mailHistory.title }}</label>
            </td>
            <td
              class="table_message"
              @click="toDetail(mailHistory.mailHistoryId)"
            >
              <div class="message">{{ mailHistory.message }}</div>
            </td>
            <td class="table_date" @click="toDetail(mailHistory.mailHistoryId)">
              <label>{{ mailHistory.sendDateTime }}</label>
            </td>
            <td
              class="table_result"
              @click="toDetail(mailHistory.mailHistoryId)"
            >
              <div>
                <div>
                  <label>{{ totalLabel }}</label>
                  <label>{{ mailHistory.total }}</label>
                </div>
                <div>
                  <label>{{ successLabel }}</label>
                  <label>{{ mailHistory.success }}</label>
                </div>
                <div>
                  <label>{{ failureLabel }}</label>
                  <label>{{ mailHistory.failure }}</label>
                </div>
                <div>
                  <label>{{ unsentLabel }}</label>
                  <label>{{ mailHistory.unsent }}</label>
                </div>
              </div>
            </td>
            <td
              class="table_userId"
              @click="toDetail(mailHistory.mailHistoryId)"
            >
              <label>{{ mailHistory.userId }}</label>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setMailHistories(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFailureModal">
      <failureModalWindow :question="failureWord" @close="close">
      </failureModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import Pagination from 'vue-pagination-2'
import failureModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      typeLabel: '送信契機',
      titleLabel: 'タイトル',
      messageLabel: '本文',
      dateLabel: '送信日時',
      userIdLabel: '送信管理者ID',
      resultLabel: '送信結果',
      totalLabel: '総数　：',
      successLabel: '成功　：',
      failureLabel: '失敗　：',
      unsentLabel: '未送信：',
      failureWord: '',
      showFailureModal: false,
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0
    }
  },
  computed: {
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.mailHistory.total
      ) {
        return this.$store.state.mailHistory.total
      }

      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >= this.$store.state.mailHistory.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.mailHistory.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    mailHistoryList() {
      return this.$store.state.mailHistory.mailHistories
    },
    formatDateList() {
      var items = []
      for (let mailHistory of this.mailHistoryList) {
        var item = Object()
        item.mailHistoryId = mailHistory.mailId
        switch (mailHistory.type) {
          case 0:
            item.type = '一斉'
            break
          case 1:
            item.type = '個別'
            break
          case 2:
            item.type = '閾値超過'
            break
          case 3:
            item.type = '更新予約処理結果'
            break
          default:
            item.type = ''
        }
        item.title = mailHistory.title
        item.message = mailHistory.message
        item.userId = mailHistory.userId
        item.total = mailHistory.total
        item.success = mailHistory.success
        item.failure = mailHistory.failure
        item.unsent = mailHistory.unsent
        var date = new Date(mailHistory.sendDateTime)
        item.sendDateTime =
          date.getFullYear() +
          '/' +
          this.padZero(date.getMonth() + 1) +
          '/' +
          this.padZero(date.getDate()) +
          '  ' +
          this.padZero(date.getHours()) +
          ':' +
          this.padZero(date.getMinutes()) +
          ':' +
          this.padZero(date.getSeconds())
        items.push(item)
      }
      return items
    }
  },
  components: {
    controlbar,
    Pagination,
    failureModalWindow,
    loadingModalWindow
  },
  async created() {
    this.$store.dispatch('systemAdminDefine/clearCompanyInfo')
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.state.prevSearchWord = ''
    let dateNow = new Date()
    const startDate = new Date(dateNow.getTime())
    startDate.setDate(dateNow.getDate() - 7)
    this.$store.dispatch('mailHistory/setSearchStartDateTime', startDate)
    this.$store.dispatch('mailHistory/setSearchEndDateTime', dateNow)
    this.setMailHistories(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    close() {
      this.showFailureModal = false
    },
    async setMailHistories(pageNo, searchWord = null) {
      this.showloadingModal = true
      let endDateTime = this.$store.state.mailHistory.searchEndDateTime
      let startDateTime = this.$store.state.mailHistory.searchStartDateTime
      // 空チェック
      if (startDateTime === null) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        let eventType = 9
        let reason = 'MSGCRD0119'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0119.name +
          this.sysErrorMsg.MSGCRD0119.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      if (endDateTime === null) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        let eventType = 9
        let reason = 'MSGCRD0120'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0120.name +
          this.sysErrorMsg.MSGCRD0120.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      startDateTime = startDateTime.getTime()
      endDateTime = endDateTime.getTime()
      if (startDateTime > endDateTime) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        let eventType = 9
        let reason = 'MSGCRD0118'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0118.name +
          this.sysErrorMsg.MSGCRD0118.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        searchWord =
          searchWord === null ? this.$store.state.prevSearchWord : searchWord
        await this.$store.dispatch('mailHistory/setMailHistories', {
          pageNo: pageNo,
          startDateTime: startDateTime,
          endDateTime: endDateTime,
          searchWord: searchWord
        })
        if (pageNo > 0) {
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        } else {
          this.page = 1
        }
        this.$store.state.prevSearchWord = searchWord
      } catch (error) {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_690001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0116')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async toDetail(mailHistoryId) {
      this.showloadingModal = true
      this.$store.dispatch('mailHistory/setSelectMailHistoryId', mailHistoryId)
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('mailHistory/setMailHistoriesDetail', {
          mailHistoryId: mailHistoryId
        })
        this.$router.push('/master/mailHistory/detail')
      } catch (error) {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_690001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0117')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (this.sysErrorMsg[errorMessage]) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else if (error.response && error.response.data) {
        this.failureWord =
          this.sysErrorMsg[errorNumber].name +
          this.sysErrorMsg[errorNumber].value +
          'エラーコード：{' +
          eventNumber +
          '}'
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    },
    padZero(num) {
      return num < 10 ? '0' + num : num
    }
  }
}
</script>
<style scoped>
.control_bar {
  background-color: #bbffff;
}
.bottom {
  background-color: #bbffff;
}
.content,
.bottom {
  width: calc(100% - 262px);
}
td {
  table-layout: fixed;
  word-break: break-word;
}
table {
  width: 100%;
}
.table_margin {
  width: 2%;
}
.table_from {
  width: 8%;
}
.table_title {
  width: 20%;
}
.table_message {
  width: 30%;
}
.table_date {
  width: 15%;
}
.table_userId {
  width: 15%;
}
.table_result {
  width: 10%;
}
.title {
  word-break: break-word;
}
.message {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.content_title {
  background-color: #ddffff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/mailHistory/mailHistoryList.vue